import http from "../../axios-config/g-http-metodos";

function getEstados(){
    const { res, erro, requisicao } = http.get('Estado/get')
    return {EstadosArray: res, erro, requisicao}
}

const EstadoController = {
    getEstados
}

export default EstadoController;
